// Mock data for Crew Up landing page

export const howItWorksSteps = [
  {
    step: 1,
    title: "Staff create profiles & get verified",
    description: "Hospitality professionals sign up, complete their profile with experience and skills, then pass our background verification process.",
    icon: "UserCheck"
  },
  {
    step: 2,
    title: "Businesses post shifts instantly",
    description: "Restaurants, hotels, and event venues post available shifts with just a few clicks. Set requirements, hours, and rates.",
    icon: "CalendarPlus"
  },
  {
    step: 3,
    title: "Get matched, work, and get paid",
    description: "Our smart matching connects the right staff with the right shifts. Work, complete the job, and receive fast payment.",
    icon: "Banknote"
  }
];

export const businessBenefits = [
  {
    title: "Fill last-minute shifts",
    description: "Got a no-show? Need extra hands for a busy weekend? Find verified staff in minutes, not days.",
    icon: "Clock"
  },
  {
    title: "Reduce downtime and no-shows",
    description: "Our rating system and verification process ensures you get reliable, committed staff every time.",
    icon: "TrendingDown"
  },
  {
    title: "Access vetted, rated staff",
    description: "Every worker on Crew Up is background-checked and rated by other businesses. Hire with confidence.",
    icon: "Star"
  }
];

export const staffBenefits = [
  {
    title: "Work flexible hours",
    description: "Choose when you want to work. Pick up shifts that fit your schedule, whether it's weekends, evenings, or one-off gigs.",
    icon: "Calendar"
  },
  {
    title: "Choose your shifts",
    description: "Browse available opportunities and apply to the ones that match your skills and preferences.",
    icon: "MousePointerClick"
  },
  {
    title: "Get paid fast",
    description: "No more waiting weeks for payment. Complete your shift and receive your earnings quickly and securely.",
    icon: "Zap"
  }
];

export const trustFeatures = [
  {
    title: "Background checks",
    description: "Every staff member undergoes comprehensive background verification before joining the platform.",
    icon: "ShieldCheck"
  },
  {
    title: "Verified profiles",
    description: "Identity verification and work history validation ensures you're connecting with real professionals.",
    icon: "BadgeCheck"
  },
  {
    title: "Ratings & reviews",
    description: "Transparent two-way rating system helps maintain high standards for both businesses and staff.",
    icon: "MessageSquareMore"
  }
];

export const stats = [
  { value: "500+", label: "Staff Ready" },
  { value: "50+", label: "Partner Venues" },
  { value: "24/7", label: "Platform Access" },
  { value: "4.9", label: "Avg Rating" }
];
